<script>
import Vue from 'vue';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

export default Vue.component('vue-select', {
    extends: vSelect,
    methods: {
        maybeAdjustScroll: () => false
    }
});
</script>



// WEBPACK FOOTER //
// src/components/general/VueSelect.vue